import {Injectable} from '@angular/core';
import * as EmployeeModels from '@employee-models/index';
import {ProfileService} from './profile.service';


const VISIBLE_PHOTO_STATUSES = [
    EmployeeModels.DE.PhotoStatusEnum.ApprovalPending,
    EmployeeModels.DE.PhotoStatusEnum.FurtherReview,
    EmployeeModels.DE.PhotoStatusEnum.Approved,
    EmployeeModels.DE.PhotoStatusEnum.ResubmissionPending,
];

const CANCEL_PHOTO_STATUSES_USI = [
    EmployeeModels.DE.PhotoStatusEnum.Approved,
    EmployeeModels.DE.PhotoStatusEnum.ApprovalPending,
];

const DISABLED_PHOTO_STATUSES = [
    EmployeeModels.DE.PhotoStatusEnum.Approved
];

const VISIBLE_BADGE_STATUSES = [
    EmployeeModels.DE.BadgeStatusEnum.Pending,
    EmployeeModels.DE.BadgeStatusEnum.Printing,
    EmployeeModels.DE.BadgeStatusEnum.CreatedInTransfer,
    EmployeeModels.DE.BadgeStatusEnum.ReadyToPickUp,
    EmployeeModels.DE.BadgeStatusEnum.ShippedTo,
    EmployeeModels.DE.BadgeStatusEnum.PendingPhotoCompliance];

const CANCEL_BADGE_STATUSES_USI = [
    EmployeeModels.DE.BadgeStatusEnum.Pending,
    EmployeeModels.DE.BadgeStatusEnum.ApprovedByManager,
    EmployeeModels.DE.BadgeStatusEnum.ApprovalNeeded,
    EmployeeModels.DE.BadgeStatusEnum.ReadyForPrinting,
    EmployeeModels.DE.BadgeStatusEnum.Printing,
    EmployeeModels.DE.BadgeStatusEnum.CreatedInTransfer,
    EmployeeModels.DE.BadgeStatusEnum.ReadyToPickUp,
    EmployeeModels.DE.BadgeStatusEnum.PendingPhotoCompliance,
];


const DISABLED_BADGE_STATUSES = [
    EmployeeModels.DE.BadgeStatusEnum.Printing,
    EmployeeModels.DE.BadgeStatusEnum.CreatedInTransfer,
    EmployeeModels.DE.BadgeStatusEnum.ReadyToPickUp,
    EmployeeModels.DE.BadgeStatusEnum.ShippedTo,
];


@Injectable()
export class ProfileEmployeeService extends ProfileService {

    isCancelBadgeRequestVisible(photoRequestStatusId: number, badgeRequestStatusId: number): boolean {
        return VISIBLE_BADGE_STATUSES.includes(badgeRequestStatusId) && VISIBLE_PHOTO_STATUSES.includes(photoRequestStatusId);
    }

    isCancelBadgeRequestVisibleUSI(photoRequestStatusId: number, badgeRequestStatusId: number): boolean {
        return CANCEL_BADGE_STATUSES_USI.includes(badgeRequestStatusId) && CANCEL_PHOTO_STATUSES_USI.includes(photoRequestStatusId);
    }


    isCancelBadgeRequestDisabled(photoRequestStatusId: number, badgeRequestStatusId: number): boolean {
        return DISABLED_BADGE_STATUSES.includes(badgeRequestStatusId) && DISABLED_PHOTO_STATUSES.includes(photoRequestStatusId);
    }
}
